import PropTypes from "prop-types"
import React from "react"
import { FORM_NAMES, URL_PATHS } from "constants/index"
import { Row, Col, CardBody, Card, Container } from "reactstrap"
import PageMetaTags from "components/PageMetaTags"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { loginUser, apiError, socialLogin } from "../../store/actions"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { SaveButton } from "components/Buttons"
import { Field, reduxForm } from "redux-form"
import { TextField } from "components/RenderInput"

const required = value => (value ? undefined : "This field is required")
const emailIsValid = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid Email"
    : undefined

const Login = props => {
  const loginSubmit = data => {
    props.loginUser(
      { email: data?.email, password: data?.password },
      props.history
    )
  }

  return (
    <React.Fragment>
      <PageMetaTags title={"Login"} />

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to enCappture.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Row>
                      <Col>
                        <Field
                          name="email"
                          type="email"
                          component={TextField}
                          label="Email"
                          validate={[required, emailIsValid]}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Field
                          name="password"
                          type="password"
                          component={TextField}
                          label="Password"
                          validate={[required]}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3 d-grid">
                      <Col>
                        <SaveButton
                          color="primary"
                          content="Log In"
                          loading={props?.loading}
                          fullWidth={true}
                          onClick={props?.handleSubmit(loginSubmit)}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-4 text-center">
                      <Col>
                        <Link to={URL_PATHS.FORGET_PWD} className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { error, loading } = state.Login
  return { error, loading }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(
    reduxForm({ form: FORM_NAMES.LOGIN_FORM })(Login)
  )
)

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
